module.exports = __webpack_public_path__ + "7fb33423b4d5fdd1522f2c977134da48.pdf";